const slugify = (value) =>
  String(value ?? '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const getProductSlug = (product) => {
  const existingSlug =
    product?.product_slug ??
    product?.slug ??
    product?.seo_slug ??
    product?.url_slug;

  if (existingSlug != null && String(existingSlug).trim()) {
    return String(existingSlug).trim().replace(/^\/+|\/+$/g, '');
  }

  const nameSlug = slugify(product?.name ?? product?.product_name);
  if (nameSlug) return nameSlug;

  const id = product?.product_id ?? product?.id;
  return id == null ? '' : String(id);
};

export const getProductPath = (product) => {
  const slug = getProductSlug(product);
  return slug ? `/product/${encodeURIComponent(slug)}` : null;
};
